import { View } from 'react-native';

import { ServiceModeBar } from 'components/app-header/mobile-header/service-mode-bar';
import { CardModalHeader } from 'components/card-modal-header';
import { HeaderPoints } from 'pages/cart/header-points';
import { t } from 'state/intl/translations';

import { DebugToggleButton } from './debug-toggle-button';

export const CartHeader = () => {
  return (
    <>
      <CardModalHeader
        {...{
          headerText: t('yourOrder'),
          dismissType: 'back',
          invertHeaderColor: true,
          customHeaderRight: (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <HeaderPoints />
              <DebugToggleButton />
            </View>
          ),
          isFullScreen: true,
        }}
      />
      <ServiceModeBar hideTopOrderStatusBar isInCart={true} />
    </>
  );
};
